import { find, first } from 'lodash';
import React from 'react';
import { FilterButton } from 'src/pages/consumer/components/DishFirstHeader';
import {
  useIsContentShowing,
  useSubCuisineFiltersReducer,
  useSubCuisineFiltersState,
} from 'src/pages/consumer/components/DishFirstHeader/store';
import { useCachedDishFirstFilters } from '../../hooks';
import { useAllCuisinesShowing } from '../../store';
import {
  formatSubcuisines,
  getRootCuisineForCuisine,
  getSubcuisinesForCuisine,
  isSubCuisine,
} from '../ExploreFilterModals/CuisineFilterModal/utils';

export const SubCuisineFilterButton: React.FC = () => {
  const { isShowing, toggle } = useSubCuisineFiltersReducer();
  const { showAllCuisines } = useAllCuisinesShowing();
  const { filters, availableCuisineCategories, allCuisineCategories } = useCachedDishFirstFilters({
    onChangeFilters: showAllCuisines,
  });

  const { cuisineFilters } = filters;

  const cuisineFilterButtonIsShowing = useSubCuisineFiltersState();
  const isContentShowing = useIsContentShowing();
  const selectedCuisineId = first(cuisineFilters) ?? '';
  const selectedCuisine = find(allCuisineCategories, { id: selectedCuisineId });
  const rootCuisine = getRootCuisineForCuisine(selectedCuisine);
  const subCuisines = getSubcuisinesForCuisine(rootCuisine, availableCuisineCategories);
  const formattedSubCuisines = formatSubcuisines(selectedCuisineId, rootCuisine, subCuisines);

  const hasSubcuisineSelection = formattedSubCuisines.some((x) => x.isSelected);

  return !formattedSubCuisines.length ? null : (
    <FilterButton
      isActive={isShowing}
      onClick={toggle}
      order={2}
      show={cuisineFilterButtonIsShowing || isContentShowing}
      hasSelection={hasSubcuisineSelection}>
      {(isSubCuisine(selectedCuisine, rootCuisine) && selectedCuisine?.title) || 'Subcuisine'}
    </FilterButton>
  );
};
